module.exports = __webpack_public_path__ + "static/media/loop.aa37ee0c.ogg";